import { BaseURI } from "../..";
import { Executor } from "../../Executor";

export const getAllPacks = (page, limit, search) => {
  const params = new URLSearchParams();

  if (page !== undefined) params.append("page", page);
  if (limit !== undefined) params.append("limit", limit);
  if (search !== undefined && search !== "") params.append("search", search);
  return Executor({

    method: "get",
    url: BaseURI + `/api/pack/packs?${params.toString()}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const createPack = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/pack/pack`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const editPack = (id, data) => {
  return Executor({
    method: "put",
    url: BaseURI + `/api/pack/pack/${id}`,
    data, // Include the updated user data in the request payload
    isSilent: false,
    successFun: (data) => {
      // You can handle success logic here if needed
    },
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const deletePack = (id) => {
  return Executor({
    method: "delete",
    url: BaseURI + `/api/pack/pack/${id}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const getAllPackName = (id, page, limit, search) => {
  const params = new URLSearchParams();

  if (page !== undefined) params.append("page", page);
  if (limit !== undefined) params.append("limit", limit);
  if (search !== undefined && search !== "") params.append("search", search);
  return Executor({
    method: "get",
    url: BaseURI + `/api/pack-names/packnames?${params.toString()}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const createPackName = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/pack-names/addpackname`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};


export const editPackName = (id, data) => {
  return Executor({
    method: "put",
    url: BaseURI + `/api/pack-names/packname/${id}`,
    data, // Include the updated user data in the request payload
    isSilent: false,
    successFun: (data) => {
      // You can handle success logic here if needed
    },
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const deletePackName = (id) => {
  return Executor({
    method: "delete",
    url: BaseURI + `/api/pack-names/packname/${id}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};


export const getAllLignePack = (page, limit, search) => {
  const params = new URLSearchParams();

  if (page !== undefined) params.append("page", page);
  if (limit !== undefined) params.append("limit", limit);
  if (search !== undefined && search !== "") params.append("search", search);
  return Executor({

    method: "get",
    url: BaseURI + `/api/ligne-pack/ligne-pack?${params.toString()}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const createLignePack = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/ligne-pack/ligne-pack`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const editLignePack = (id, data) => {
  return Executor({
    method: "put",
    url: BaseURI + `/api/ligne-pack/ligne-pack/${id}`,
    data, // Include the updated user data in the request payload
    isSilent: false,
    successFun: (data) => {
      // You can handle success logic here if needed
    },
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const deleteLignePack = (id) => {
  return Executor({
    method: "delete",
    url: BaseURI + `/api/ligne-pack/ligne-pack/${id}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};


export const getPackAiPremium = (page, limit, idClient) => {
  const params = new URLSearchParams();

  if (page !== undefined) params.append("page", page);
  if (limit !== undefined) params.append("limit", limit);
 if (idClient !== undefined && idClient !== null && idClient !== "" && idClient !== "null") {
    params.append("idClient", idClient);
  }  return Executor({

    method: "get",
    url: BaseURI + `/api/ai-pack?${params.toString()}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const createPackAiPremium = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/ai-pack`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};


export const deletePackAiPremium = (id) => {
  return Executor({
    method: "delete",
    url: BaseURI + `/api/ligne-pack/ligne-pack-premium/${id}`,
    isSilent: false,
    successFun: (data) => {},
    withErrorToast: false,
    withSuccessToast: false,
  });
};

/******************************************** */

export const getPackCheckWithoutTVA = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/facture/checkWithoutTVA`,
    isSilent: false,
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const getPackExcelSearcher = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/articles/getExcelSearcher`,
    isSilent: false,
    withErrorToast: false,
    withSuccessToast: false,
  });
};

export const getPackInvoice = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/facture/checkPackInvoice`,
    isSilent: false,
    withErrorToast: false,
    withSuccessToast: false,
  });
};
export const getPackExcelReport = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/articles/checkExcelReport`,
    isSilent: false,
    withErrorToast: false,
    withSuccessToast: false,
  });
};
export const getPackArticleAttributes = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/articles/checkArticleAttributes`,
    isSilent: false,
    withErrorToast: false,
    withSuccessToast: false,
  });
};
export const getPackTagDLC = (data) => {
  return Executor({
    method: "post",
    data,
    url: BaseURI + `/api/articles/checkTagDLC`,
    isSilent: false,
    withErrorToast: false,
    withSuccessToast: false,
  });
};

